'use strict'

/**
 * 計測用の軽量ユーティリティ（既定は無効）。 ブラウザのコンソールで `window.__MATRIX_PERF__ = true` を実行したときだけ、 派生計算（スクリプト処理）とテーブルの再レンダー（コミット）の所要時間を
 * console.debug に出力する。 これにより「計算が重いのか／描画が重いのか」を切り分け、Web Worker（計算オフロード）と 仮想スクロール（描画削減）のどちらが有効かを判断できる。本番では何も出力しない。
 */

/**
 * 計測が有効かどうか（window.**MATRIX_PERF** === true のときのみ）。
 *
 * @returns {boolean}
 */
export function isMatrixPerfEnabled() {
  return typeof window !== 'undefined' && window.__MATRIX_PERF__ === true
}

/**
 * 計測有効時のみ fn の所要時間を計測してログ出力する。無効時はそのまま fn を実行する。
 *
 * @template T
 * @param {string} label - ログ名
 * @param {() => T} fn - 計測対象
 * @returns {T}
 */
export function measureMatrixPerf(label, fn) {
  if (!isMatrixPerfEnabled()) return fn()
  const t0 = performance.now()
  const result = fn()
  // eslint-disable-next-line no-console
  console.debug(`[matrix-perf] ${label}: ${(performance.now() - t0).toFixed(1)}ms`)
  return result
}

/**
 * 計測有効時のみ、与えられたミリ秒をログ出力する（React Profiler の onRender など外部計測値の出力用）。
 *
 * @param {string} label - ログ名
 * @param {number} ms - ミリ秒
 * @returns {void}
 */
export function logMatrixPerf(label, ms) {
  if (!isMatrixPerfEnabled()) return
  // eslint-disable-next-line no-console
  console.debug(`[matrix-perf] ${label}: ${ms.toFixed(1)}ms`)
}
